import { CSSObject } from "styled-components";
import { vfxTheme } from "../VFX-UI/Theme/theme";

interface ButtonStyles {
    noBackgroundColor: CSSObject;
    newButton: CSSObject;
    newIcon: CSSObject;
    iconText: CSSObject;
    xCloseButton: CSSObject;
    editButton: CSSObject;
    searchButton: CSSObject;
    exportButton: CSSObject;
    searchIcon: CSSObject;
    actionDots: CSSObject;
    printButton: CSSObject;
}

const useButtonStyles = (): ButtonStyles => {
    
    return {
        newButton: {
            backgroundColor: vfxTheme.palette.primary.main,
            color: vfxTheme.palette.background.default,
            marginLeft: vfxTheme.spaceUnits.sp03,
            display: "flex",
            alignItems: "center"
        },
        newIcon: {
            color: vfxTheme.palette.background.default,
            marginRight: vfxTheme.spaceUnits.sp01,
            fontSize: "1.5em"
        },
        iconText: {
            marginLeft: vfxTheme.spaceUnits.sp01,
            fontSize: "1.25em",
            fontFamily: vfxTheme.fontFamily
        },
        noBackgroundColor: {
            backgroundColor: vfxTheme.palette.background.default,
            color: vfxTheme.palette.text.primary,
        },
        xCloseButton: {
            backgroundColor: vfxTheme.palette.background.default,
            color: vfxTheme.palette.primary.main,
            fontSize:"1.25em"
        },
        editButton: {
            backgroundColor: vfxTheme.palette.background.default,
            color: vfxTheme.palette.primary.main,
            fontSize: "1.25em",
            paddingTop: 0
        },
        searchButton: {
            backgroundColor: vfxTheme.palette.blueGreys.bg50,
            borderColor: vfxTheme.palette.blueGreys.bg200,
            color: vfxTheme.palette.blueGreys.bg600,
            minWidth: "65px",
        },
        exportButton: {
            backgroundColor: vfxTheme.palette.blueGreys.bg50,
            borderColor: vfxTheme.palette.blueGreys.bg200,
            color: vfxTheme.palette.blueGreys.bg600,
            minWidth: "65px",
        },
        searchIcon: {
            //fontSize: "28px!important",
            margin: "0!important",
            fontSize:"1.5em"
        },
        actionDots: {
            fontSize: "2em",
            color: vfxTheme.palette.text.primary,
        },
        printButton: {
            backgroundColor: vfxTheme.palette.primary.main,
            color: vfxTheme.palette.background.default,
            marginLeft: vfxTheme.spaceUnits.sp03,
            display: "flex",
            alignItems: "center"
        },
    };
};

export default useButtonStyles;
